import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}));

function DataTable(props) {
  const { children } = props;
  const classes = useStyles();

  return (
    <Paper classes={{ root: classes.root }}>
      {children}
    </Paper>
  );
}

DataTable.propTypes = propTypes;

export default DataTable;
